const metrics = {
  baseMargin: '30px',
};

export default metrics;
